import { ReactNode } from 'react'
import { ArrowForward } from '@mui/icons-material'
import { Card, CardHeader, IconButton, SxProps } from '@mui/material'

interface CardLinkProps {
    label: string
    onClick: (_: any) => void
    sx?: SxProps
    icon?: ReactNode
}

const defaultSx: SxProps = {
    'mb': 2,
    ':hover': {
        cursor: 'pointer',
        boxShadow: 2
    }
}

const defaultIcon = <ArrowForward />

const CardLink = ({ label, onClick, sx, icon }: CardLinkProps) => {
    return (
        <Card sx={{ ...defaultSx, ...sx }} elevation={0} onClick={onClick}>
            <CardHeader
                title={label}
                action={
                    <IconButton aria-label="settings">
                        {icon || defaultIcon}
                    </IconButton>
                }
            />
        </Card>
    )
}

export default CardLink
